/**
 * Credibility block script.
 *
 * Stagger fade-in across the trust badge images — opacity only, no translate
 * (third-party logos with their own visual weight don't need positional motion).
 */

import { revealStagger, motionTokens } from '@/motion-primitives';

document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.rmh-credibility').forEach((section) => {
		const badgesRow = section.querySelector('.flex.flex-wrap');
		if (!badgesRow) return;

		revealStagger(badgesRow, {
			childSelector: ':scope > a, :scope > img',
			stagger: 0.07,
			duration: motionTokens.durMd,
			distance: 0,
		});
	});
});
